import { Link, usePage } from "@inertiajs/react"
import { ShieldAlert } from "lucide-react"

/**
 * Persistent "you are impersonating someone" pill with a one-click way back.
 *
 * Reads the globally shared `impersonator` prop (ApplicationController includes
 * the Impersonation concern), so it renders on every surface an impersonated
 * session can reach — admin/coach/member portals, the intake wizard, and the
 * report page. Renders nothing for everybody else, which is virtually every
 * request.
 *
 * Fixed-position on purpose: the impersonated account may land on a page with
 * no navigation at all (Report/Show), and the return path has to be present
 * there too.
 */
export function ImpersonationBanner() {
  const impersonator = usePage().props?.impersonator

  if (!impersonator) return null

  return (
    <div className="fixed bottom-20 left-4 right-4 sm:bottom-4 sm:right-auto sm:max-w-md z-[100] print:hidden">
      <div className="flex items-center gap-3 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 shadow-lg">
        <ShieldAlert className="h-4 w-4 shrink-0 text-amber-700" />
        <p className="min-w-0 flex-1 text-xs text-amber-900">
          Viewing as{" "}
          <span className="font-semibold">{impersonator.viewingAs}</span> —
          signed in as {impersonator.name || impersonator.email}.
        </p>
        <Link
          href={impersonator.returnPath}
          method="post"
          as="button"
          className="shrink-0 rounded-md bg-amber-700 px-2.5 py-1 text-xs font-medium text-white hover:bg-amber-800"
        >
          Return to admin
        </Link>
      </div>
    </div>
  )
}

export default ImpersonationBanner
